import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

function AreasServed({ areas, selected_areas }) {
  const [selectedAreas, setSelectedAreas] = useState(selected_areas);

  const unselectedAreas = useMemo(() => {
    return areas.filter(a => !selectedAreas.some(sa => sa.id === a.id));
  }, [areas, selectedAreas]);

  const addArea = area => {
    setSelectedAreas([...selectedAreas, area]);
  };

  const removeArea = area => {
    setSelectedAreas(selectedAreas.filter(a => a.id !== area.id));
  };

  return (
    <div className="input areas-served-wrapper">
      <label className="" htmlFor="user_area_ids">
        Areas Served
      </label>
      {/* Select with options is what rails needs to update the agent's areas, Please don't remove */}
      <select
        aria-label="Area Select"
        className="hidden"
        multiple="multiple"
        name="user[area_ids][]"
        id="user_area_ids"
      >
        {selectedAreas.map(a => (
          <option key={a.id} value={a.id} selected="selected">
            {a.id}
          </option>
        ))}
        {unselectedAreas.map(a => (
          <option key={a.id} value={a.id}>
            {a.id}
          </option>
        ))}
      </select>
      <div className="areas-served-container">
        {selectedAreas.map(a => (
          <button
            key={a.id}
            type="button"
            className="mls-area selected"
            onClick={e => {
              e.preventDefault();
              removeArea(a);
            }}
          >
            <p>{a.name} X</p>
          </button>
        ))}
        {unselectedAreas.map(a => (
          <button
            key={a.id}
            type="button"
            className="mls-area"
            onClick={e => {
              e.preventDefault();
              addArea(a);
            }}
          >
            <p>{a.name}</p>
          </button>
        ))}
      </div>
    </div>
  );
}

AreasServed.propTypes = {
  areas: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  selected_areas: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};

export default AreasServed;
